import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { AnchorLink, HoverAnimation, Image } from '@gik/ui';

export interface IHomepageBadgeProps {
  icon: string;
  title: string;
  jumpTo: string;
}

export function HomepageBadge({ icon, title, jumpTo }: IHomepageBadgeProps) {
  const bem = bemBlock('homepage-badge');
  const offset = -85;

  return (
    <HoverAnimation>
      <AnchorLink to={jumpTo} className={bem()} spy={true} smooth={true} offset={offset}>
        <Image className={bem('icon')} src={icon} />
        <section className={bem('title')}>{title}</section>
      </AnchorLink>
    </HoverAnimation>
  );
}
